<div class="abbr" [innerHTML]="content">
</div>
